/*
 * @Author: zhaozhuo
 * @Date: 2021-12-06 15:03:07
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-01-05 11:01:46
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\request\api\visitForm.js
 */
import { get, post } from '../axios'
const visitForm = {
	// 查询访视中表单列表
	getSubjectVisitList: (subjectCode, visitCode, researchCode) => get(`/web/recruitCenter/getVisitFormList/${subjectCode}/${visitCode}/${researchCode}`),
	// 查询录入阶段的访视表单列表
	getSubjectVisitFormList: params => get(`/web/subjectVisit/getSubjectVisitFormList/${params}`),
	// 查询非计划和通用重复访视列表
	getUnplannedRepeatVisitList: params => get(`/web/subjectVisit/getUnplannedAndUniversalRepeatVisitList/${params}`),
	// 新增重复访视
	addRepeatVisit: params => post('/web/subjectVisit/addUnplannedOrUniversalRepeatVisit', params),
	// 删除重复访视
	deleteSubjectRepateVisit: (subjectCode, params) => post(`/web/subjectVisit/deleteSubjectVisit/${subjectCode}`, params),
	// 患者提交表单后，可选择给医生推送表单
	pushFormMsgToDoctor: params => get('/web/recruitCenter/formSubmit', params),
	// 请求复诊
	addFollowUpRepeatVisit: (params) => post(`/web/subjectVisit/addFollowUpRepeatVisit`, params),
	// 获取请求复诊状态
	getSubjectVisitStatus: (visitCode) => get(`/web/subjectVisit/getOne/${visitCode}`),
	// 请求复诊同意、回复
	updateApplyStatus: (params) => post(`/web/subjectVisit/updateApplyStatus`, params)
}
export default visitForm